import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'membrowse_color_scheme';
const GREEN_INCREASE = 'green-increase';
const RED_INCREASE = 'red-increase';

const useColorScheme = () => {
  const [colorScheme, setColorSchemeState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || GREEN_INCREASE;
    } catch {
      return GREEN_INCREASE;
    }
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-color-scheme', colorScheme);
  }, [colorScheme]);

  const setColorScheme = useCallback((scheme) => {
    setColorSchemeState(scheme);
    try {
      localStorage.setItem(STORAGE_KEY, scheme);
    } catch {
      // localStorage unavailable
    }
  }, []);

  const toggleColorScheme = useCallback(() => {
    const next = colorScheme === GREEN_INCREASE ? RED_INCREASE : GREEN_INCREASE;
    setColorScheme(next);
  }, [colorScheme, setColorScheme]);

  return { colorScheme, toggleColorScheme, isRedIncrease: colorScheme === RED_INCREASE };
};

export default useColorScheme;
